<app-img-header
  title="Paquetes Financieros"
  alt="Daimler Truck"
  image="/assets/images/cotizador/intro.jpg"
  [subTitle]="selectedVersion"
  [contentTemplate]="template"
>
</app-img-header>
<app-preloader *ngIf="isLoading"></app-preloader>
<app-notifications></app-notifications>
<main class="main" id="">
  <div id="detail">
    <div class="pageWidth">
      <div class="actionsWrapper">
        <button *ngIf="isAdministrator" class="tertiary" [routerLink]="['/quote/financial-setup/new-setup']">
          <i class="icon"></i> Nuevo paquete financiero
        </button>
      </div>

      <!-- Mostra solamente si no hay datos -->
      <div class="noData" *ngIf="!hasData">No hay información disponible</div>

      <!-- Tabla con paquetes financieros -->
      <div class="customTable paquetesFinancieros" *ngIf="hasData">
        <div class="header">
          <div class="cell nombre">Nombre</div>
          <div class="cell version">Versión</div>
          <div class="cell producto">Producto financiero</div>
          <div class="cell estado">Estado</div>
          <div class="cell vigente">Vigente</div>
          <div class="cell acciones"></div>
        </div>

        <!-- Si un paquete tiene más de 1 versión y la linea que se muestra es la versión aprobada, se debe incluir adicionalmente la clase "current" en el div.row -->
        <ng-container *ngFor="let item of data; index as i">
          <div class="row" [ngClass]="{ current: changeCss(i) }">
            <div class="cell nombre">
              {{ show(i) ? item.financialSetupName : '' }}
            </div>
            <div class="cell version">{{ item.version }}</div>
            <div class="cell producto">
              {{ show(i) ? serviceStandard.getFinancialProduct(item.financialProduct) : '' }}
            </div>
            <div class="cell estado">
              <!-- Definir clase "borrador, enAprobacion, aprobado, rechazado o descontinuado" según corresponda -->
              <span class="tag" [ngClass]="showStatusLowerCase(item)">{{ showStatus(item) }}</span>
            </div>
            <div class="cell vigente">
              <!-- {{ item.active ? "Si" : "No" }} -->
              <img
                *ngIf="item.active && item.status == 'APPROVED'"
                [ngClass]="{ 'hidden-icon': !show(i) || !item.active }"
                src="../../assets/images/icons/notification_success.svg"
                alt="Si"
                class="available"
                tp="Vigente"
              />
              <img
                *ngIf="!item.active && item.status == 'APPROVED'"
                [ngClass]="{ 'hidden-icon': !show(i) || item.active }"
                src="../../assets/images/icons/notification_error.svg"
                alt="No"
                class="notAvailable"
                tp="No vigente"
              />
            </div>
            <div class="cell acciones">
              <a (click)="view(item.id)" class="view" tp="Ver">Ver</a>
              @if (this.isAdministrator) {
                <!-- <a (click)="edit(item.id)" tp="Editar" class="edit">Editar</a> -->
                <a class="duplicate" tp="Duplicar" (click)="duplicate(item.id)" *ngIf="item.status != 'DRAFT'"
                  >Duplicar</a
                >
                <a *ngIf="item.status != 'APPROVED'" class="delete" tp="Eliminar" (click)="openModalConfirmation(item)"
                  >Eliminar</a
                >
              }
            </div>
          </div>
        </ng-container>
        <!-- Fila para la tabla, repetir con cada registro -->
      </div>
      <div *ngIf="hasData">
        <app-paginator
          [total]="total"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (changePage)="handlePage($event)"
        ></app-paginator>
      </div>

      <div class="actionsWrapper">
        <button *ngIf="isAdministrator" class="tertiary" [routerLink]="['/quote/financial-setup/new-setup']">
          <i class="icon"></i> Nuevo paquete financiero
        </button>
      </div>
    </div>
  </div>
</main>
<ng-template #template>
  <div class="wrapperG3">
    <div>
      <label>Nombre</label>
      <app-input [data]="searchName" (textSearch)="filter($event, 'name')" [resetInput]="reset"></app-input>
    </div>
    <div>
      <label>Producto financiero</label>
      <app-select
        [options]="financialProducts"
        [placeholder]="'Buscar por producto financiero'"
        [resetSelect]="reset"
        (optionSelected)="filter($event, 'financialProduct')"
      ></app-select>
    </div>
    <div>
      <label>Estado</label>
      <app-select
        [options]="FinancialSetupStatus"
        [placeholder]="'Buscar por estado'"
        [resetSelect]="reset"
        (optionSelected)="filter($event, 'status')"
      ></app-select>
    </div>
  </div>
  <div class="wrapperG3" style="margin-top: 20px">
    <div>
      <!-- Incluir opciones correspondientes (Vigente, No vigente) -->
      <label>Vigencia</label>
      <app-select
        [options]="FinancialSetupActiveCurrently"
        [placeholder]="'Buscar por vigencia'"
        [resetSelect]="reset"
        [defaultValue]="true"
        (optionSelected)="filter($event, 'active')"
      ></app-select>
    </div>
  </div>
  <div class="filtersActions">
    <button class="primary" (click)="search()">Buscar</button>
    <button class="secondary" (click)="resetFilters()">Limpiar filtros</button>
  </div>
</ng-template>
<ng-template #templateConfirmation>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="deleteSetup()"
  ></app-template-confirmation>
</ng-template>
